module.exports = __webpack_public_path__ + "img/奖章1级@2x.d0a734bd.png";